// This file was originally auto-generated. Modified to read from environment
// variables so the same codebase works against dev and production Supabase instances.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// Exported so raw fetch() callers (e.g. GET edge-function calls that supabase-js
// invoke() can't express) resolve the same URL/key as the client — including the
// hardcoded fallbacks used when env vars aren't build-injected (local dev).
export const SUPABASE_URL =
  import.meta.env?.VITE_SUPABASE_URL ||
  "https://zjrunwdpivpurubjosqi.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env?.VITE_SUPABASE_ANON_KEY ||
  import.meta.env?.VITE_SUPABASE_PUBLISHABLE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpqcnVud2RwaXZwdXJ1Ympvc3FpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTExNjI4NzEsImV4cCI6MjA2NjczODg3MX0.SH080A12R0JWChrOVbsG97sF0nDuznT5kvn1BEWKud8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
